import React from 'react';
import {View, Text} from '@react-pdf/renderer';
import styles from '../styles';
import {ControlItem, ControlName} from './ControlsComponents';

const ThirdSection = props => {
  return (
    <View style={styles.row}>
      <View style={[styles.width5, styles.sectionHeader, styles.center]}>
        <Text style={[styles.text10, styles.rotated, {width: '250%'}]}>
          Çdo muaj
        </Text>
      </View>
      <View style={[styles.flex1, styles.borderLeft]}>
        <View style={[styles.row]}>
          <ControlName text="Qarqet e sigurisë" />
          <View style={styles.flex1}>
            <View style={[styles.row]}>
              <ControlItem
                text="Kontakti i krehërve"
                style={[styles.flex1]}
                noCheck
              />
              <ControlItem
                text="Lart majtas"
                selected={props.check24}
                iconWidth="6px"
                style={[styles.smallContent]}
                checkStyle={[styles.smallCheck]}
              />
              <ControlItem
                text="Lart djathtas"
                selected={props.check25}
                iconWidth="6px"
                style={[styles.smallContent]}
                checkStyle={[styles.smallCheck]}
              />
              <ControlItem
                text="Poshtë majtas"
                selected={props.check26}
                iconWidth="6px"
                style={[styles.smallContent]}
                checkStyle={[styles.smallCheck]}
              />
              <ControlItem
                text="Poshtë djathtas"
                selected={props.check27}
                iconWidth="6px"
                style={[styles.smallContent]}
                checkStyle={[styles.smallCheck]}
              />
            </View>
            <View style={styles.row}>
              <ControlItem
                text="Kontakti i sigurisë në rast të devijimit së shkelëses"
                noCheck
                style={[styles.flex1]}
              />
              <ControlItem
                text="Lart"
                selected={props.check28}
                style={[styles.center, {width: '11.6%'}]}
              />
              <ControlItem
                text="Poshtë"
                selected={props.check29}
                style={[styles.center, {width: '12.8%'}]}
              />
            </View>
            <View style={[styles.row]}>
              <ControlItem
                text="Kontakti i anësorëve"
                style={[styles.flex1]}
                noCheck
              />
              <ControlItem
                text="Lart majtas"
                selected={props.check30}
                iconWidth="6px"
                style={[styles.smallContent]}
                checkStyle={[styles.smallCheck]}
              />
              <ControlItem
                text="Lart djathtas"
                selected={props.check31}
                iconWidth="6px"
                style={[styles.smallContent]}
                checkStyle={[styles.smallCheck]}
              />
              <ControlItem
                text="Poshtë majtas"
                selected={props.check32}
                iconWidth="6px"
                style={[styles.smallContent]}
                checkStyle={[styles.smallCheck]}
              />
              <ControlItem
                text="Poshtë djathtas"
                selected={props.check33}
                iconWidth="6px"
                style={[styles.smallContent]}
                checkStyle={[styles.smallCheck]}
              />
            </View>
            <View style={styles.row}>
              <ControlItem
                text="Kontakti në rast të mbingarkimit (vetëm për tapeta lëvizëse)"
                noCheck
                style={[styles.flex1]}
              />
              <ControlItem
                text="Lart"
                selected={props.check34}
                style={[styles.center, {width: '11.6%'}]}
              />
              <ControlItem
                text="Poshtë"
                selected={props.check35}
                style={[styles.center, {width: '12.8%'}]}
              />
            </View>
            <View style={[styles.row]}>
              <ControlItem
                text="Kontakti hyrës i parmakut të gomës"
                style={[styles.flex1]}
                noCheck
              />
              <ControlItem
                text="Lart majtas"
                selected={props.check36}
                iconWidth="6px"
                style={[styles.smallContent]}
                checkStyle={[styles.smallCheck]}
              />
              <ControlItem
                text="Lart djathtas"
                selected={props.check37}
                iconWidth="6px"
                style={[styles.smallContent]}
                checkStyle={[styles.smallCheck]}
              />
              <ControlItem
                text="Poshtë majtas"
                selected={props.check38}
                iconWidth="6px"
                style={[styles.smallContent]}
                checkStyle={[styles.smallCheck]}
              />
              <ControlItem
                text="Poshtë djathtas"
                selected={props.check39}
                iconWidth="6px"
                style={[styles.smallContent]}
                checkStyle={[styles.smallCheck]}
              />
            </View>
            <View style={styles.row}>
              <ControlItem
                text="Kontakti i zinxhirit ngasës"
                noCheck
                style={[styles.flex1]}
              />
              <ControlItem
                text="Zinxhiri 1"
                selected={props.check40}
                style={[styles.center, {width: '23.5%'}]}
              />
              <ControlItem
                text="Zinxhiri 2 (nëse ka)"
                selected={props.check41}
                style={[styles.center, {width: '29.3%'}]}
              />
            </View>
            <View style={[styles.row]}>
              <ControlItem
                text="Kontakti i zinxhirit të shkelëseve"
                style={[styles.flex1]}
                noCheck
              />
              <ControlItem
                text="Poshtë majtas"
                selected={props.check42}
                iconWidth="6px"
                style={[styles.smallContent]}
                checkStyle={[styles.smallCheck]}
              />
              <ControlItem
                text="Poshtë djathtas"
                selected={props.check43}
                iconWidth="6px"
                style={[styles.smallContent]}
                checkStyle={[styles.smallCheck]}
              />
            </View>
            <View style={[styles.row]}>
              <ControlItem
                text="Qarqe të tjera të sigurisë"
                style={[styles.flex1]}
                noCheck
              />
              <ControlItem
                text={props.check44Text}
                selected={props.check44}
                iconWidth="6px"
                style={[styles.smallContent, {width: '12%'}]}
                checkStyle={[styles.smallCheck]}
              />
              <ControlItem
                text={props.check45Text}
                selected={props.check45}
                iconWidth="6px"
                style={[styles.smallContent, {width: '13.2%'}]}
                checkStyle={[styles.smallCheck]}
              />
              <ControlItem
                text={props.check46Text}
                selected={props.check46}
                iconWidth="6px"
                style={[styles.smallContent, {width: '15.2%'}]}
                checkStyle={[styles.smallCheck]}
              />
              <ControlItem
                text={props.check47Text}
                selected={props.check47}
                iconWidth="6px"
                style={[styles.smallContent, {width: '16.2%'}]}
                checkStyle={[styles.smallCheck]}
              />
            </View>
          </View>
        </View>
        <View style={[styles.row]}>
          <ControlName text="Distanca e frenimit" />
          <View style={styles.flex1}>
            <View style={styles.row}>
              <ControlItem
                text="Kontrollo bobinën e frenave"
                selected={props.check48}
              />
              <ControlItem
                text="Distanca e ndaljes (frenimit) në lëvizje të lirë (max 300mm)"
                selected={props.check49}
                style={[styles.flex1]}
              />
            </View>
            <View style={styles.row}>
              <ControlItem
                text="Nëse kërkohet rregullimi (kalibrimi) a është bërë?"
                style={[styles.flex1]}
                selected={props.check50}
              />
            </View>
          </View>
        </View>
      </View>
    </View>
  );
};

export default ThirdSection;
